/* eslint-disable @nx/enforce-module-boundaries */
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import Head from 'next/head';
import { forwardRef } from 'react';
import { AppendPageHeadTitle } from 'v4/snippets/custom-head';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { SearchLayout } from 'v4/snippets/search/layout';
import { SearchTeams } from 'v4/snippets/search/teams';
import { TeamsContext, useTeamsContext } from 'v4/snippets/teams/context';
export default forwardRef(({ ...props }, ref) => {
  const teamsCtx = useTeamsContext({});
  const { t } = useTranslator();
  return (
    <AuthenticatedProviders>
      <SearchLayout activeTab={'team'}>
        <TeamsContext.Provider value={teamsCtx}>
          <Head>
            <title>{t('otherPage.joinGroupOr') || "Join Groups or Communities at myBridge"}</title>
            <meta
              name="og:title"
              content="Join Groups or Communities at myBridge"
            />
            <meta
              name="description"
              content="Join communities or groups to connect, share, and grow together where meaningful interactions thrive. Connect with people who matter to you."
            />
            <meta
              name="og:description"
              content="Join communities or groups to connect, share, and grow together where meaningful interactions thrive. Connect with people who matter to you."
            />
            <link
              rel="canonical"
              href={`${typeof window !== 'undefined' && window.location.href}`}
            />
          </Head>
          <SearchTeams />
        </TeamsContext.Provider>
      </SearchLayout>
    </AuthenticatedProviders>
  );
});
